export default "__VITE_ASSET__BOTk$y9N__"